import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  padding: 20px;

  .shareButton {
    width: 334px;
    height: 50px;
    margin-bottom: 20px;

    font-weight: bold;

    @media (max-width: 400px) {
      width: 100%;
    }
  }
`;

export const OrangeBox = styled.div`
  background-color: ${props => props.theme.colors.primary.main};
  height: 212px;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1070px) {
    padding: 20px;
  }

  @media (max-width: 575px) {
    flex-direction: column;
    height: unset;
  }
`;

export const Item = styled.div`
  width: 220px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1070px) {
    width: unset;
  }
`;

export const ItemText = styled.span`
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  font-weight: bold;

  @media (max-width: 1070px) {
    width: 150px;
  }
`;

export const ItemDivider = styled.div`
  border: 2px dashed #000000;
  width: 182px;
  height: 0;
  margin-bottom: 62px;

  @media (max-width: 1070px) {
    width: 20%;
  }

  @media (max-width: 575px) {
    width: 80%;
    margin: 20px 0 20px 0;
  }
`;

export const ControlPanel = styled.div`
  .container {
    margin-top: 20px;

    display: flex;
    justify-content: space-between;

    h1 {
      font-size: 34px;
      span {
        font-size: 12px;
        margin-left: 10px;
      }
    }
    h2 {
      font-size: 12px;
    }

    .loadingBigCard {
      height: 48px;
      width: 60px;
    }

    @media (max-width: 769px) {
      flex-direction: column;
    }
  }

  .bigCard {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 45%;
    height: 160px;
    padding: 20px;

    border: 1px solid;
    border-radius: 22px;
    box-shadow: 4px 4px black;

    h2 {
      margin-bottom: 10px;
    }

    .cashInProcess {
      display: flex;
      justify-content: space-between;

      width: 300px;
      margin-top: 10px;
      padding: 10px;

      border: 1px solid #fe501c;
      border-radius: 12px;
      box-shadow: 4px 4px #fe501c;

      span {
        color: #fe501c;
      }
      @media (max-width: 390px) {
        width: 100%;
      }
      .loadingCashInProcess {
        height: 16px;
        width: 80px;
      }
    }

    @media (max-width: 769px) {
      width: 100%;
      height: 160px;
      margin-bottom: 20px;
    }
  }

  .card {
    display: flex;
    flex-direction: column;

    width: 25%;
    height: 160px;
    padding: 20px;

    border: 1px solid;
    border-radius: 22px;
    box-shadow: 4px 4px black;

    //width: calc(50% - 10px); /* 50% do tamanho do container menos a margem */
    //margin-right: 20px; /* Margem entre os cards */

    h1 {
      margin-top: 10px;
    }
    span {
      margin-top: 10px;
      color: rgb(44 255 0);
    }

    @media (max-width: 769px) {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;

export const WhiteBox = styled.div`
  margin-top: 20px;
  padding: 40px 0;
  background-color: #fff;
  border-radius: 22px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AlignDescription = styled.div`
  padding: 20px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Description = styled.div`
  text-align: center;
`;

export const CopyBox = styled.div`
  background: #e4e4e4;
  border-radius: 8px;

  width: 334px;
  height: 50px;
  padding: 0 10px;

  display: flex;
  align-items: center;
  text-align: center;

  justify-content: center;

  @media (max-width: 400px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 10px;
    overflow: auto;
  }
`;

export const CopyBoxText = styled.span`
  font-family: ${props => props.theme.font.default};
  overflow-wrap: anywhere;
`;

export const CopyButton = styled.div`
  padding-top: 10px;
`;

export const SubTitle = styled.span`
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
  font-weight: bold;
  color: #525252;
`;

export const SocialMedias = styled.div`
  height: 46px;
  margin-bottom: 20px;
`;

export const SocialMediaButton = styled.button`
  padding-top: 20px;
  padding: 8px;
`;

export const SocialMedia = styled.img`
  height: 38px;
  width: 38px;
`;
